/**
 * 客户端插件：监听未授权事件并执行登出
 * 这个插件只在客户端运行，避免 SSR 构建时的副作用
 */
export default defineNuxtPlugin(() => {
  if (process.client && typeof window !== 'undefined') {
    const authStore = useAuthStore()

    // 监听 http.ts 触发的未授权事件，执行登出逻辑（避免循环依赖）
    window.addEventListener('auth:unauthorized', () => {
      authStore.logout()
    })
  }
})
